import { render, staticRenderFns } from "./StockHeadOuter.vue?vue&type=template&id=6c90da1c&scoped=true"
import script from "./StockHeadOuter.vue?vue&type=script&lang=js"
export * from "./StockHeadOuter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c90da1c",
  null
  
)

export default component.exports